module.exports = __webpack_public_path__ + "img/happytablet_product4.3f31eec2.jpg";